import {VisualisationDataInterface} from "../models/visualisation-data.interface";

export const visualisationData: VisualisationDataInterface[] = [
    {
        region: {
            Americas: [41, 22, 38],
            EMEA: [53, 24, 26],
            "Asia-Pacific": [36, 27, 37],
        },
        sector: {
            "Oil and gas": [42, 31, 28],
            "Hard-to-abate sectors": [45, 21, 34],
            "Renewable energy": [40, 14, 46],
        },
        revenue: {
            "$200bn or more": [12, 6, 82],
            "$10bn to $199bn": [31, 9, 60],
            "$2bn to $9.99bn": [46, 23, 31],
            "$50m to $1.99bn": [47, 30, 24],
        },
    },
    {
        region: {
            Americas: [32, 22, 46],
            EMEA: [42, 22, 37],
            "Asia-Pacific": [50, 22, 28],
        },
        sector: {
            "Oil and gas": [34, 20, 45],
            "Hard-to-abate sectors": [48, 22, 30],
            "Renewable energy": [34, 28, 36],
        },
        revenue: {
            "$50m to $1.99bn": [56, 23, 21],
            "$2bn to $9.99bn": [36, 25, 38],
            "$10bn to $199bn": [9, 16, 73],
            "$200bn or more": [0, 0, 100],
        },
    }
]

export const visualisationDataForBars: VisualisationDataInterface[] = visualisationData.map(
    yearlyData => ({
        ...yearlyData,
        revenue: Object.fromEntries(
            Object.entries(yearlyData.revenue).reverse()
        ),
    }));